import each from 'lodash/each';
import assertHasProperty from './assertHasProperty';

export default (object: unknown, ...properties: string[]) =>
  each(properties, (property) => assertHasProperty(object, property));
